import { css } from '@emotion/react'
import { Alert as MuiAlert, Divider as MuiDivider, styled } from '@mui/material'
import { colors } from '@global/constants/colors'

export const SuccessAlertTitle = styled('div')`
  font-weight: bold;
  font-size: 14px;

  ${({ theme }) => `
    color: ${theme.palette.success.dark};
  `}
`

export const ErrorAlertTitle = styled('div')`
  color: ${colors.red.dark};
  font-weight: 500;
  font-size: 14px;
`

export const Alert = styled(MuiAlert)`
  border-radius: 8px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  ${({ type }: { type: 'success' | 'error' }) =>
    type === 'success' &&
    css`
      background-color: #edf7ed;
    `}

  ${({ type }: { type: 'success' | 'error' }) =>
    type === 'error' &&
    css`
      background-color: #feeceb;
    `}
`

export const Divider = styled(MuiDivider)`
  margin-top: 5px;
  margin-bottom: 5px;
`

export const FilePath = styled('div')`
  font-size: 12px;
  color: #3e3e3e;
`

export const ErrorOutput = styled('div')`
  font-size: 12px;
  color: ${colors.red.dark};
`
